// 24 h
export const ANIMATION_PERIOD   = 86400
export const ANIMATION_TIMES    = [20, 40]
export const ANIMATION_KEY      = 'au'